import apiClient from 'helpers/api-client'
import { getIdToken } from 'helpers/auth'
import { sendLog } from 'helpers/log'

export const getOneTimeToken = async () => {
  try {
    const oneTimeToken = await apiClient.get(
      '/authentication/hub/v1/token',
      { headers: { Authorization: getIdToken() } },
    )
    return oneTimeToken
  } catch (error) {
    sendLog(error)
  }
}
